import { useCallback, useRef } from 'react';
import { requestFocus } from '../../Shared/Utils';

export default function useSceltaServizioDefaults(
  selezioneBloccata,
  servizio,
  categoria,
  areaSelezionata,
  categoriaRef,
) {
  const valoriDefaultRef = useRef(selezioneBloccata ? { servizio, categoria } : { areaSelezionata, categoria });

  const eseguiUnaVoltaSeDefaultDefinito = useCallback((propName, callback) => {
    if (valoriDefaultRef.current[propName]) {
      if (propName === 'servizio' || propName === 'areaSelezionata') {
        requestFocus(categoriaRef);
      }
      callback(valoriDefaultRef.current[propName]);
      valoriDefaultRef.current[propName] = undefined;
    }
  }, [categoriaRef]);

  return eseguiUnaVoltaSeDefaultDefinito;
}
